// @flow weak

import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import { isStatelessComponent } from 'app/common/utils/ReactUtils';

const purify = (displayName, Render) => {
  if (typeof Render === 'undefined') {
    Render = displayName;
    displayName = Render.displayName || Render.name || 'Pure';
  }

  const isRenderComponent = !isStatelessComponent(Render);

  return createReactClass({
    displayName,

    /* eslint-disable react/forbid-foreign-prop-types */
    propTypes: !isRenderComponent && Render.propTypes ? Render.propTypes : {},
    /* eslint-enable react/forbid-foreign-prop-types */

    mixins: [PureRenderMixin],

    render() {
      return isRenderComponent ? (
        <Render {...this.props} />
      ) : (
        Render(this.props)
      );
    },
  });
};

export default purify;
